module.exports = __webpack_public_path__ + "img/cnn.66023e21.png";